export const vowelMutation = (text) => {
  let result = "";
    result = text.replaceAll("ae", "ä");
    result = result.replaceAll("Ae", "Ä");
    result = result.replaceAll("ue", "ü");
    result = result.replaceAll("Ue", "Ü");
    result = result.replaceAll("oe", "ö");
    result = result.replaceAll("Oe", "Ö");
    result = result.replaceAll("sss", "ß");
    return result;
}